'use client';

import { useSearchParams } from 'next/navigation';

import { useMountEffect } from '@/hooks/useMountEffect';

const DEFAULT_GAME_CODE = 'ligm_vipautoroulette';

export function Hub88GamesListDebug() {
  const searchParams = useSearchParams();
  const enabled = searchParams.get('hub88Debug') === '1';
  const gameCode = searchParams.get('code') || searchParams.get('gamecode') || DEFAULT_GAME_CODE;

  useMountEffect(() => {
    if (!enabled) {
      return;
    }

    void fetch(`/api/integrations/casino/hub/games-list?code=${encodeURIComponent(gameCode)}`)
      .then(async (response) => {
        const data: unknown = await response.json();
        console.warn('[Hub88] game/list debug (client)', data);
      })
      .catch((error: unknown) => {
        console.warn('[Hub88] game/list debug failed', error);
      });
  });

  return null;
}
